export default {
  duration: 'Duration',
  recipeStepUp: 'Move recipe step up',
  recipeStepDown: 'Move recipe step down',
  recipeStepDuplicate: 'Duplicate recipe step',
};
